/**
 * Formats a reference to a single record for a page title, e.g. `Employer 'Stord' (24286)`.
 *
 * The name leads because a tab strip truncates, and the name is what tells two tabs apart at a
 * glance. The id is kept alongside it so a title still matches the URL, and stands on its own
 * (`Employer 24286`) until the name has loaded, or when the record has no name to show.
 */
export const recordLabel = (
  noun: string,
  id: string | number | null | undefined,
  name?: string | null,
): string => (name ? `${noun} '${name}' (${id})` : `${noun} ${id}`)
